import { PropsWithChildren, createContext, useState } from "react"
import INBAInsightsContext from "./context"
import { Game, Player, Playlist, Team } from "../client"
import { GameSearchData, PlayerSearchData } from "../models/SearchData"

export const NBAInsightsContext = createContext<INBAInsightsContext>({
    // NBA STORE
    nbaPlayers: [],
    setNbaPlayers: () => {},
    nbaTeams: [],
    setNbaTeams: () => {},

    // WNBA STORE
    wnbaPlayers: [],
    setWnbaPlayers: () => {},
    wnbaTeams: [],
    setWnbaTeams: () => {},

    // OTHER STORE
    games: [],
    setGames: () => {},

    // SEARCH STORE
    isSearchOpen: false,
    setIsSearchOpen: () => {},
    searchHistory: [],
    setSearchHistory: () => {},
    playerSearchData: null,
    setPlayerSearchData: () => {},
    gameSearchData: null,
    setGameSearchData: () => {},

    // PLAYLIST STORE
    userPlaylists: [],
    setUserPlaylists: () => {},
    publicPlaylists: [],
    setPublicPlaylists: () => {}
})

export const NBAInsightsContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
    // NBA STORE
    const [nbaPlayers, setNbaPlayers] = useState<Player[]>([])
    const [nbaTeams, setNbaTeams] = useState<Team[]>([])

    // WNBA STORE
    const [wnbaPlayers, setWnbaPlayers] = useState<Player[]>([])
    const [wnbaTeams, setWnbaTeams] = useState<Team[]>([])

    // OTHER
    const [games, setGames] = useState<Game[]>([])

    // SEARCH STORE
    const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false)
    const [searchHistory, setSearchHistory] = useState<{title: string, url: string, pos: number}[]>([])
    const [playerSearchData, setPlayerSearchData] = useState<PlayerSearchData | null>(null)
    const [gameSearchData, setGameSearchData] = useState<GameSearchData | null>(null)
    
    // PLAYLIST STORE
    const [userPlaylists, setUserPlaylists] = useState<Playlist[]>([])
    const [publicPlaylists, setPublicPlaylists] = useState<Playlist[]>([])

    const defaultContext: INBAInsightsContext = {
        // NBA STORE
        nbaPlayers,
        setNbaPlayers,
        nbaTeams,
        setNbaTeams,
        
        // WNBA STORE
        wnbaPlayers,
        setWnbaPlayers,
        wnbaTeams,
        setWnbaTeams,

        // OTHER STORE
        games,
        setGames,

        // SEARCH STORE
        isSearchOpen,
        setIsSearchOpen,
        searchHistory,
        setSearchHistory,
        playerSearchData,
        setPlayerSearchData,
        gameSearchData,
        setGameSearchData,

        // PLAYLIST STORE
        userPlaylists,
        setUserPlaylists,
        publicPlaylists,
        setPublicPlaylists,
    }

    return <NBAInsightsContext.Provider value={defaultContext}>
        { children }
    </NBAInsightsContext.Provider>
}